import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from 'slate-react'
import Container from '@hixme-ui/container'

import PostToolbar from './PostToolbar/PostToolbar'
import { renderNode, renderMark } from '../../rules/schema'

const PostEditor = ({
  editorValue,
  setValue,
  onKeyDown,
  placeholder,
  style,
}) => (
  <div
    style={{
      marginBottom: '10px',
      border: '1px solid #b9c5cd',
      backgroundColor: '#eff3f5',
      ...style,
    }}
  >
    <PostToolbar value={editorValue} setValue={setValue} />
    <Container>
      <Editor
        className="editor"
        placeholder={placeholder}
        renderNode={renderNode}
        renderMark={renderMark}
        onChange={setValue}
        onKeyDown={onKeyDown}
        value={editorValue}
      />
    </Container>
  </div>
)

PostEditor.displayName = 'PostEditor'

PostEditor.propTypes = {
  editorValue: PropTypes.object,
  placeholder: PropTypes.string,
  setValue: PropTypes.func,
  onKeyDown: PropTypes.func,
  style: PropTypes.object,
}

PostEditor.defaultProps = {
  editorValue: {},
  placeholder: '',
  setValue: null,
  onKeyDown: null,
  style: {},
}

export default PostEditor
